export default __webpack_public_path__ + "static/media/map2.3ba43740.png";